import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'fac_requires_pregnancy_tests_that_are_not_required_by_applicabl'

export const dataPointDefinition = {
  retracedId: 'fac_requires_pregnancy_tests_that_are_not_required_by_applicabl',
  name: 'Facility requires pregnancy tests that are not required by applicable legislation',
  description:
    'Consult applicable legal requirements before answering this question.\r\r\n\r\r\nPregnancy tests are only acceptable under very limited circumstances. They must be legally required to protect pregnant/ nursing women from work that is legally prohibited or restricted for them, or from work that presents a recognized significant risk to the health of the mother and child.\r\r\n\r\r\nSelect this item if the tests were performed for other reasons, or if the tests were not legally required.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'rh-dis-42',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 5790,
  sectionId: '2.2.5',
  impactArea: 'Discrimination, Violence or Harassment',
  impactAreaId: 'DISCRIMINATION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
